export default "__VITE_ASSET__DOoL$FBw__"